module.exports = __webpack_public_path__ + "assets/chartnext.9238313f.svg";